export enum SceneIndex {
    ADD_TO_HOME_SCREEN = "ADD_TO_HOME_SCREEN",
    TUTORIAL = "TUTORIAL",
    MY_BUILDINGS = "MY_BUILDINGS",
    MENU = "MENU",
    UPGRADE = "UPGRADE",
    COOKIES = "COOKIES",
    CASHOUT = "CASHOUT",
    ALLOW_NOTIFICATIONS = "ALLOW_NOTIFICATIONS",
    STORE_INTRODUCTION = "STORE_INTRODUCTION",
    DICE_ROLLS_OFFER = "DICE_ROLLS_OFFER",
    CHECKOUT_FIX_UPGRADE = "CHECKOUT_FIX_UPGRADE",
    AUTH = "AUTH",
    SOCIAL_COMMUNITIES = "SOCIAL_COMMUNITIES",
    SOCIAL = "SOCIAL",
    NEWS = "NEWS",
    PIGGY = "PIGGY",
    CHECKOUT_PIGGY = "CHECKOUT_PIGGY",
    RENTER_POLICY_INTRODUCTION = "RENTER_POLICY_INTRODUCTION",
    TOURNAMENT_INTRODUCTION = "TOURNAMENT_INTRODUCTION",
    LEADERBOARD_INTRODUCTION = "LEADERBOARD_INTRODUCTION"
}
